import React, { useState, useEffect } from "react";
import axios from "axios";
import APIURL from "../../common/Config";
import { useNavigate } from "react-router-dom";
import "./bank.css";
import Header from "../header/header";
import Footer from "../footer/footer";
import LocalDBApi from "../../api-manager/LocalDBManager.component"; 

const BankDetailsForm = () => {
  const [form, setForm] = useState({
    astrologerId: "", 
    mobileNo: "", 
    aadharNumber: "", 
    panNumber: "", 
    accountHolderName: "", 
    accountNumber: "", 
    ifscCode: "", 
    bankName: "", 
    branchName: "", 
    address: "", 
    city: "", 
    state: "", 
  });

  const [errors, setErrors] = useState({
    mobileNo: "",
    aadharNumber: "",
    panNumber: "",
    accountHolderName: "", 
    accountNumber: "",
    ifscCode: "",
  });

  const [error, setError] = useState(""); 
  const [branchDetails, setBranchDetails] = useState(null); 
  const [loading, setLoading] = useState(false); 
  const [touched, setTouched] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    const astrologerId = LocalDBApi.getFromLocalStorage("ASTROLOGERID");
    if (astrologerId) {
      setForm((prev) => ({
        ...prev,
        astrologerId: astrologerId,
      }));
    } else {
      console.error("Astrologer ID not found in Local Storage");
      setError("Astrologer ID not found");
    }
  }, []);
  
  const validateField = (name, value) => {
    let errorMessage = "";
    
    switch(name) {
      case "mobileNo":
        if (!value.trim()) {
          errorMessage = "Mobile Number is required";
        } else if (!/^\d{10}$/.test(value)) {
          errorMessage = "Mobile Number should be 10 digits";
        }
        break;
      
      case "aadharNumber":
        if (!value.trim()) {
          errorMessage = "Aadhar Number is required";
        } else if (!/^\d{12}$/.test(value)) {
          errorMessage = "Aadhar Number should be 12 digits";
        }
        break;
      
      case "panNumber":
        if (!value.trim()) {
          errorMessage = "PAN Number is required";
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
          errorMessage = "Invalid PAN Number format (e.g. ABCDE1234F)";
        }
        break;
      
      case "accountHolderName":
        if (!value.trim()) {
          errorMessage = "Account Holder Name is required";
        }
        break;
      
      case "accountNumber":
        if (!value.trim()) {
          errorMessage = "Account Number is required";
        } else if (value.length < 9 || value.length > 18) {
          errorMessage = "Account Number should be between 9-18 digits";
        } else if (!/^\d+$/.test(value)) {
          errorMessage = "Account Number should contain only digits";
        }
        break;
      
      case "ifscCode":
        if (!value.trim()) {
          errorMessage = "IFSC Code is required";
        } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
          errorMessage = "Invalid IFSC Code format";
        }
        break;
      
      default:
        break;
    }
    
    return errorMessage;
  };

  const handleChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
    
   
    setTouched(prev => ({ ...prev, [name]: true }));
    
    
    const fieldError = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: fieldError }));
  };

  const handleBlur = (name) => {
    setTouched(prev => ({ ...prev, [name]: true }));
    const fieldError = validateField(name, form[name]);
    setErrors(prev => ({ ...prev, [name]: fieldError }));
  };
  
  const fetchDetails = async (ifsc) => {
    if (ifsc.length === 11) {
      try {
        const response = await axios.get(`${APIURL}/bank/validate/${ifsc}`);
        const data = response.data;
        if (data) {
          setForm((prev) => ({
            ...prev,
            bankName: data.BANK || "",
            branchName: data.BRANCH || "",
            address: (data.ADDRESS || "").replace(/\s+/g, " ").trim(),
            city: data.CITY || "",
            state: data.STATE || "",
          }));
          setBranchDetails(data);
          setError("");
        } else {
          setError("No branch details found for this IFSC code.");
        }
      } catch (error) {
        setError("Branch details not found or network error.");
      }
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    
    
    Object.keys(errors).forEach(key => {
      const fieldError = validateField(key, form[key]);
      newErrors[key] = fieldError;
      if (fieldError) isValid = false;
    });
    
    setErrors(newErrors);
    
   
    const allTouched = {};
    Object.keys(errors).forEach(key => {
      allTouched[key] = true;
    });
    setTouched(allTouched);
    
    return isValid;
  };
  
  const handleSubmit = async () => {
    if (!validateForm()) {
      setError("Please correct the errors before submitting.");
      return;
    }
  
    setLoading(true);
    setError("");
  
    try {
      const response = await axios.post(
        `${APIURL}/astrologer/bank-details/save`,
        form 
      );
      
      
      setForm({
        astrologerId: "",
        mobileNo: "",
        aadharNumber: "",
        panNumber: "",
        accountHolderName: "",
        accountNumber: "",
        ifscCode: "",
        bankName: "",
        branchName: "",
        address: "",
        city: "",
        state: "",
      });
      navigate('/document'); 
    } catch (error) {
      console.error("Error saving bank details:", error);
      setError("Failed to save bank details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  
  const renderLabel = (label, isRequired) => (
    <label className="form-label">
      {label} {isRequired && <span className="required-asterisk">*</span>}
    </label>
  );
  
  return (
    <div>
      <Header />
      <div className="bank-form-container">
        <h2 className="bank-form-title">Enter Bank Details</h2>

       

        <div className="form-group">
          {renderLabel("Mobile Number", true)}
          <input
            type="text"
            className={`form-input ${touched.mobileNo && errors.mobileNo ? "input-error" : ""}`}
            value={form.mobileNo}
            onChange={(e) => handleChange("mobileNo", e.target.value)}
            onBlur={() => handleBlur("mobileNo")}
            maxLength={10}
            placeholder="Enter Mobile Number"
          />
          {touched.mobileNo && errors.mobileNo && (
            <div className="field-error">{errors.mobileNo}</div>
          )}
        </div>

        <div className="form-group">
          {renderLabel("Aadhar Number", true)}
          <input
            type="text"
            className={`form-input ${touched.aadharNumber && errors.aadharNumber ? "input-error" : ""}`}
            value={form.aadharNumber}
            onChange={(e) => handleChange("aadharNumber", e.target.value)}
            onBlur={() => handleBlur("aadharNumber")}
            maxLength={12}
            placeholder="Enter Aadhar Number"
          />
          {touched.aadharNumber && errors.aadharNumber && (
            <div className="field-error">{errors.aadharNumber}</div>
          )}
        </div>

        <div className="form-group">
          {renderLabel("PAN Number", true)}
          <input
            type="text"
            className={`form-input ${touched.panNumber && errors.panNumber ? "input-error" : ""}`}
            value={form.panNumber}
            onChange={(e) => handleChange("panNumber", e.target.value.toUpperCase())}
            onBlur={() => handleBlur("panNumber")}
            maxLength={10}
            placeholder="Enter PAN Number"
          />
          {touched.panNumber && errors.panNumber && (
            <div className="field-error">{errors.panNumber}</div>
          )}
        </div>

        <div className="form-group">
          {renderLabel("Account Holder Name", true)}
          <input
            type="text"
            className={`form-input ${touched.accountHolderName && errors.accountHolderName ? "input-error" : ""}`}
            value={form.accountHolderName}
            onChange={(e) => handleChange("accountHolderName", e.target.value)}
            onBlur={() => handleBlur("accountHolderName")}
            placeholder="Enter Account Holder Name"
          />
          {touched.accountHolderName && errors.accountHolderName && (
            <div className="field-error">{errors.accountHolderName}</div>
          )}
        </div>

        <div className="form-group">
          {renderLabel("Account Number", true)}
          <input
            type="text"
            className={`form-input ${touched.accountNumber && errors.accountNumber ? "input-error" : ""}`}
            value={form.accountNumber}
            onChange={(e) => handleChange("accountNumber", e.target.value)}
            onBlur={() => handleBlur("accountNumber")}
            maxLength={18}
            placeholder="Enter Account Number"
          />
          {touched.accountNumber && errors.accountNumber && (
            <div className="field-error">{errors.accountNumber}</div>
          )}
        </div>

        <div className="form-group">
          {renderLabel("IFSC Code", true)}
          <input
            type="text"
            className={`form-input ${touched.ifscCode && errors.ifscCode ? "input-error" : ""}`}
            value={form.ifscCode}
            onChange={(e) => {
              const value = e.target.value.toUpperCase();
              handleChange("ifscCode", value);
              if (value.length === 11) fetchDetails(value);
            }}
            onBlur={() => handleBlur("ifscCode")}
            maxLength={11}
            placeholder="Enter IFSC Code"
          />
          {touched.ifscCode && errors.ifscCode && (
            <div className="field-error">{errors.ifscCode}</div>
          )}
        </div>

        {branchDetails && (
          <>
            <div className="form-group">
              <label className="form-label">Bank Name:</label>
              <input className="form-input" value={form.bankName} readOnly />
            </div>
            <div className="form-group">
              <label className="form-label">Branch Name:</label>
              <input className="form-input" value={form.branchName} readOnly />
            </div>
            <div className="form-group">
              <label className="form-label">Address:</label>
              <textarea className="form-textarea" value={form.address} readOnly />
            </div>
            <div className="form-group">
              <label className="form-label">City:</label>
              <input className="form-input" value={form.city} readOnly />
            </div>
            <div className="form-group">
              <label className="form-label">State:</label>
              <input className="form-input" value={form.state} readOnly />
            </div>
          </>
        )}
              {error && <div className="error-message">{error}</div>}
              {loading && <div className="loading-spinner">Saving...</div>}

        <button className="submit-button" onClick={handleSubmit}>
          Save Bank Details
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default BankDetailsForm;